import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Box, Button, Table, TableBody, TableRow, TableCell,
} from '@material-ui/core';
import { DeleteForeverOutlined, GetApp, Close } from '@material-ui/icons';
import {
  setSearchConditionPopFlg,
  setSearchConditionList,
  getSearchConditionList,
  getSearchCondition,
  importSearchCondition,
  exportSearchCondition,
  setImportFile,
  deleteSearchCondition,
  setDispCondition,
  setSelectConditionFlg,
  setGetAddressFlg,
  setGetIndustryFlg,
  setGetProductFlg,
  setSearchConditionSeqId,
  setSearchConditionDeletePopFlg,
  setDispConditionName,
  setAlertItem,
  setAlertMasterPopFlg,
  setErrMsgSearchConditionPop,
  setGetCustomerCompanyFlg,
  setGetSupplierCompanyFlg,
  setGetTopCompanyFlg,
  setGetTradeInfoFlg,
} from '../../actions/TargetAction';
import uploadIcon from '../../../image/upload_icon.png';
import { setSystemLodingFLg, setInitMessage } from '../../actions/CommonAction';
import { GET_MASTER_FLG } from '../../../common/const';
import styles from './PopStyles.module.css';

class TargetPopSearchConditionsComponent extends Component {
  async componentDidMount() {
    const {
      getSearchConditionListAct,
      setSearchConditionListAct,
      searchConditionPopFlg,
      setInitMessageAct,
      setErrMsgSearchConditionPopAct,
    } = this.props;

    if (searchConditionPopFlg) {
      setInitMessageAct();
      setErrMsgSearchConditionPopAct();
      const ret = await getSearchConditionListAct();
      setSearchConditionListAct(ret.targeting_criteria_list);
    }
  }

  /**
  * アラートポップアップを閉じる
  */
  closeAlertPop = () => {
    const { setSearchConditionPopFlgAct, setAlertMasterPopFlgAct } = this.props;
    setAlertMasterPopFlgAct(false);
    setSearchConditionPopFlgAct(false);
  };

  /**
  * 検索条件保存ポップアップを閉じる
  */
  closeSearchConditionPop = () => {
    const { setSearchConditionPopFlgAct } = this.props;
    setSearchConditionPopFlgAct(false);
  };

  // ファイルクリック
  importClick = () => {
    const { setErrMsgSearchConditionPopAct } = this.props;
    setErrMsgSearchConditionPopAct();
    const file = document.getElementById('importFile');
    file.click();
  }

  // 検索条件削除
  openDeletePop = async (seqId) => {
    const {
      setSearchConditionDeletePopFlgAct,
      setSearchConditionSeqIdAct,
    } = this.props;
    setSearchConditionDeletePopFlgAct(true);
    setSearchConditionSeqIdAct(seqId);
  }

  // 検索条件削除
  deleteClick = async () => {
    const {
      deleteSearchConditionAct,
      setSearchConditionDeletePopFlgAct,
      searchConditionSeqId,
    } = this.props;
    await deleteSearchConditionAct(searchConditionSeqId);
    setSearchConditionDeletePopFlgAct(false);
  }

  // 検索条件選択
  selectCondition = async (seqId, criteriaName) => {
    const {
      setDispConditionAct,
      setSelectConditionFlgAct,
      setGetAddressFlgAct,
      setGetIndustryFlgAct,
      setGetProductFlgAct,
      getSearchConditionAct,
      setSearchConditionPopFlgAct,
      setDispConditionNameAct,
      setAlertItemAct,
      setAlertMasterPopFlgAct,
      setGetCustomerCompanyFlgAct,
      setGetSupplierCompanyFlgAct,
      setGetTopCompanyFlgAct,
      setGetTradeInfoFlgAct,
    } = this.props;
    const res = await getSearchConditionAct(seqId);
    if (!res) return;
    const targetingCriteria = JSON.parse(res.criteria_json);
    setDispConditionAct(targetingCriteria);
    setSelectConditionFlgAct(true);
    // 所在地取得フラグ設定
    if (targetingCriteria.location_list) {
      setGetAddressFlgAct(GET_MASTER_FLG.ON);
    }
    // 業種取得フラグ設定
    if (targetingCriteria.industry_list) {
      setGetIndustryFlgAct(GET_MASTER_FLG.ON);
    }
    // 扱い品取得フラグ設定
    if (targetingCriteria.atsukaihin_list) {
      setGetProductFlgAct(GET_MASTER_FLG.ON);
    }
    // 取引情報取得フラグ設定
    if (targetingCriteria.trade_list) {
      setGetTradeInfoFlgAct(GET_MASTER_FLG.ON);
    }
    // 販売先取得フラグ設定
    if (targetingCriteria.hnbsk_list) {
      setGetCustomerCompanyFlgAct(GET_MASTER_FLG.ON);
    }
    // 仕入先取得フラグ設定
    if (targetingCriteria.srsk_list) {
      setGetSupplierCompanyFlgAct(GET_MASTER_FLG.ON);
    }
    // 国内最上位親会社取得フラグ設定
    if (targetingCriteria.series_top_tsr_code_list) {
      setGetTopCompanyFlgAct(GET_MASTER_FLG.ON);
    }

    if (res.alert_item_list) {
      // アラート項目があった場合、ポップアップ表示
      setAlertItemAct(res.alert_item_list.map((alertItem) => `｢${alertItem}｣`).join(''));
      setAlertMasterPopFlgAct(true);
    } else {
      // 検索条件保存ポップアップを閉じる
      setSearchConditionPopFlgAct(false);
    }
    // 吹き出し用の検索条件名を設定
    setDispConditionNameAct(criteriaName);
  }

  // エクスポート
  exportClick = async (seqId, criteriaName) => {
    const {
      exportSearchConditionAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    await exportSearchConditionAct(seqId, criteriaName, '0');
    setSystemLodingFLgAct(false);
  }

  // ファイル選択
  onChangeFile = () => {
    const {
      importSearchConditionAct,
      setSystemLodingFLgAct,
      setImportFileAct,
    } = this.props;

    const file = document.getElementById('importFile').files[0];
    setImportFileAct(file);
    if (file !== undefined) {
      // ファイルが選択されたらインポート開始
      setSystemLodingFLgAct(true);
      importSearchConditionAct(file);
      setSystemLodingFLgAct(false);

      // インポート後はファイルの選択状態を解除
      setImportFileAct('');
    }
  }

  render() {
    const {
      searchConditionPopFlg,
      searchConditionList,
      searchConditionDeletePopFlg,
      importFile,
      setSearchConditionDeletePopFlgAct,
      alertMasterPopFlg,
      alertItem,
      errMsgSearchConditionPop,
    } = this.props;

    return (
      searchConditionPopFlg && (
        <Box className={`${styles.searchCond}`}>
          <Box className={`${styles.contents}`}>
            <Box className={`${styles.header}`}>
              <Box className={`${styles.title}`}>
                保存した検索条件
              </Box>
              <Box className={`${styles.importbutton}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => this.importClick(this)}
                >
                  <img alt="uploadIcon" src={uploadIcon} />
                  条件をインポート
                </Button>
                <input type="file" id="importFile" onChange={this.onChangeFile.bind(this)} className={`${styles.uploadFile}`} value={importFile} />
              </Box>
              <Box className={`${styles.close}`} onClick={() => this.closeSearchConditionPop.bind(this)}>
                <Button
                  className={`${styles.closeButton} tooltip`}
                  variant="contained"
                  startIcon={<Close className={`${styles.closeIcon}`} />}
                  onClick={() => this.closeSearchConditionPop(this)}
                >
                  <Box className={`${styles.searchCondDescription} description`}>閉じる</Box>
                </Button>
              </Box>
            </Box>
            <Box className={`${styles.msgArea}`}>
              <span>{errMsgSearchConditionPop}</span>
            </Box>
            <Box className={`${styles.searchresultarea} ${styles.targetCondscrollbar}`}>
              <Table>
                <TableBody>
                  {searchConditionList && searchConditionList.map((result) => (
                    <TableRow key={result.seq_id}>
                      <TableCell className={`${styles.delete}`}>
                        <Button
                          className={`${styles.tooltip} tooltip`}
                          variant="contained"
                          startIcon={<DeleteForeverOutlined className={`${styles.deleteIcon}`} />}
                          onClick={() => this.openDeletePop(result.seq_id)}
                        >
                          <Box className={`${styles.searchCondDescription} description`}>条件を削除</Box>
                        </Button>
                      </TableCell>
                      <TableCell className={`${styles.export}`}>
                        <Button
                          className={`${styles.tooltip} tooltip`}
                          variant="contained"
                          startIcon={<GetApp className={`${styles.exportIcon}`} />}
                          onClick={() => this.exportClick(result.seq_id, result.criteria_name)}
                        >
                          <Box className={`${styles.searchCondDescription} description`}>条件をエクスポート</Box>
                        </Button>
                      </TableCell>
                      <TableCell className={`${styles.searchCondDescription} ${styles.criterianame}`}>
                        <Box
                          className={`${styles.item}`}
                          onClick={() => this.selectCondition(result.seq_id, result.criteria_name)}
                        >
                          {result.criteria_name}
                        </Box>
                      </TableCell>
                      <TableCell className={`${styles.searchCondDescription} ${styles.datetime}`}>
                        <Box
                          className={`${styles.item}`}
                          onClick={() => this.selectCondition(result.seq_id, result.criteria_name)}
                        >
                          {result.create_datetime}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>
          {searchConditionDeletePopFlg && (
            <Box className={`${styles.bgContents}`}>
              <Box className={`${styles.deleteContents}`}>
                <Box className={`${styles.deleteMassage}`}>
                  削除します。よろしいですか？
                </Box>
                <Box className={`${styles.deleteButton}`}>
                  <Button
                    variant="contained"
                    className="cancel"
                    onClick={() => setSearchConditionDeletePopFlgAct(false)}
                  >
                    キャンセル
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => this.deleteClick(this)}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
          {alertMasterPopFlg && (
            <Box className={`${styles.bgContents}`}>
              <Box className={`${styles.alertContents}`}>
                <Box className={`${styles.alertMassage}`}>
                  {alertItem}
                  に最新マスタでは存在しない条件が含まれます。
                </Box>
                <Box className={`${styles.alertButton}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => this.closeAlertPop()}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      ));
  }
}

export default connect(
  (state) => ({
    searchConditionDeletePopFlg: state.target.searchConditionDeletePopFlg,
    searchConditionPopFlg: state.target.searchConditionPopFlg,
    searchConditionList: state.target.searchConditionList,
    importFile: state.target.importFile,
    searchConditionSeqId: state.target.searchConditionSeqId,
    alertMasterPopFlg: state.target.alertMasterPopFlg,
    alertItem: state.target.alertItem,
    errMsgSearchConditionPop: state.target.errMsgSearchConditionPop,
    getCustomerCompanyFlg: state.target.getCustomerCompanyFlg,
    getSupplierCompanyFlg: state.target.getSupplierCompanyFlg,
    getTopCompanyFlg: state.target.getTopCompanyFlg,
  }),
  (dispatch) => ({
    setSearchConditionPopFlgAct: (bool) => dispatch(setSearchConditionPopFlg(bool)),
    getSearchConditionListAct: () => dispatch(getSearchConditionList()),
    setSearchConditionListAct: (object) => dispatch(setSearchConditionList(object)),
    getSearchConditionAct: (string) => dispatch(getSearchCondition(string)),
    exportSearchConditionAct: (seqId, criteriaName, checkMasterFlg) => dispatch(
      exportSearchCondition(seqId, criteriaName, checkMasterFlg),
    ),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setImportFileAct: (object) => dispatch(setImportFile(object)),
    deleteSearchConditionAct: (object) => dispatch(deleteSearchCondition(object)),
    setDispConditionAct: (object) => dispatch(setDispCondition(object)),
    setSelectConditionFlgAct: (object) => dispatch(setSelectConditionFlg(object)),
    setGetAddressFlgAct: (object) => dispatch(setGetAddressFlg(object)),
    setGetIndustryFlgAct: (object) => dispatch(setGetIndustryFlg(object)),
    setGetProductFlgAct: (object) => dispatch(setGetProductFlg(object)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    importSearchConditionAct: (object) => dispatch(importSearchCondition(object)),
    setSearchConditionDeletePopFlgAct: (bool) => dispatch(setSearchConditionDeletePopFlg(bool)),
    setSearchConditionSeqIdAct: (object) => dispatch(setSearchConditionSeqId(object)),
    setDispConditionNameAct: (String) => dispatch(setDispConditionName(String)),
    setAlertItemAct: (string) => dispatch(setAlertItem(string)),
    setAlertMasterPopFlgAct: (bool) => dispatch(setAlertMasterPopFlg(bool)),
    setErrMsgSearchConditionPopAct: (string) => dispatch(setErrMsgSearchConditionPop(string)),

    setGetCustomerCompanyFlgAct: (bool) => dispatch(setGetCustomerCompanyFlg(bool)),
    setGetSupplierCompanyFlgAct: (bool) => dispatch(setGetSupplierCompanyFlg(bool)),
    setGetTopCompanyFlgAct: (bool) => dispatch(setGetTopCompanyFlg(bool)),
    setGetTradeInfoFlgAct: (bool) => dispatch(setGetTradeInfoFlg(bool)),
  }),
)(TargetPopSearchConditionsComponent);
